import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import { COLOR } from 'constants/colors';
import { Row, Col } from 'antd';
import { CustomisedHr } from 'views/common-styled-components';
import { SubmitButton } from 'views/stp-swp/stp-swp-helper';
import { useHistory } from "react-router-dom";
import { getEventName, Mixpanel } from '__utils/mixpanel';

interface planProps {
    planObject: any;
    noActive?: string;
}
const PlanIntroCard = styled.div<any>`
    font-size: 16px;
    .inner-cont {
        padding: 24px 0 0 0;
        display: flex;
    } 
    .imgAlign{
        text-align: center;
        margin-top: ${(props: any) => props.isMobile ? '' : '24px'};
    }
    .imgAlign img{
        padding-top: ${(props: any) => props.isMobile ? '16px' : ''};
    }
    .mediumScreen{
        height: ${(props: any) => props.noActive === 'STP' ? '350px' : props.noActive === 'SWP' ? '320px' : ''};
        padding-right:16px;
    }
`;
const PlanTitle = styled.div<CommonStyledComponentProps>`
    margin-top: ${(props: any) => props.isMobile ? '24px' : '0'};
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 8px;
`;
const PlanDescription = styled.p`
    color: ${COLOR.GREY3};
    line-height: 19px;
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 16px;
`;
const GreyContainer = styled.div<any>`
    background: ${COLOR.GREY_BG};
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 16px;

    .decIcon{
        color: #00a465 !important;
        font-weight: bold; 
        font-size: 1.6em;
        display: inline-block;
        width: 1em; 
        vertical-align: middle;
        padding-left: 1em;
        line-height: 0;
    }   
    ul {
        list-style: none;
        text-indent: -24px; 
        margin-left: 24px;
    }
    .li-item{
        color: ${COLOR.GREY3};
        font-size: ${(props: any) => props.isMobile ? '14px' : '16px'};
        font-weight: 400;
        line-height: 1.5;
        margin-top: 8px;

    }

`;

export const greyBgPlanDescComponent = (descParams: any, isMobile: boolean) => {
    return <GreyContainer isMobile={isMobile}>
        <PlanTitle isMobile={isMobile} style={{marginTop:'0'}}>{descParams.question}</PlanTitle>
        {
            <ul className="palnUl">
                {descParams.answers.map((element: string, key: number) => (
                    <li className="li-item" key={key}><i className="decIcon">•</i>{element}</li>)
                )}
            </ul>
        }
    </GreyContainer>
}
export const headerDescComponent = (headerProp: any, isMobile: boolean, history: any) => {
    return (<div className='mb16'>
        <PlanTitle isMobile={isMobile}>{headerProp.title}</PlanTitle>
        <div style={{ display: 'flex', gap: '5%' }}>
            <PlanDescription>{headerProp.description}</PlanDescription>
            {!isMobile && <SubmitButton width={isMobile ? '' : '200px'} onClick={() => { Mixpanel.track(getEventName("setupNewSTP", "clicked", "profile")); history.push('stps/create-new-stp') }}>Setup New STP</SubmitButton>}
        </div>
    </div>)
}

const PlanIntro: React.FC<planProps> = ({ planObject, noActive }: planProps) => {
    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const isBigScreen = useMediaQuery({ minWidth: 1281 });

    return <PlanIntroCard isMobile={isMobile} noActive={noActive}>
        <div>
            <Row gutter={32} style={{ flexDirection: isMobile ? 'column' : 'row-reverse', justifyContent: 'space-between' }} >
                <Col xs={24} md={12} xl={11} style={{ paddingLeft: isMobile ? '16px' : '0' }}>
                    <div className="imgAlign">
                        <img src={planObject.image} alt="image" width="100%" className={isBigScreen ? 'bigScreen' : !isMobile ? 'mediumScreen' : ''} />
                        {isMobile && <br />}
                    </div>
                    {isMobile && <br />}
                </Col>
                <Col xs={24} md={12} xl={isBigScreen ? 13 : 13}>
                    {headerDescComponent(planObject, isMobile, history)}
                    {greyBgPlanDescComponent(planObject, isMobile)}
                    <CustomisedHr style={{ marginBottom: "4px" }} />
                    {noActive && <p className="greyTxt" style={{ margin: '16px 0 32px 0', fontSize: '14px' }}>You don’t have any Active {noActive}</p>}

                </Col>

            </Row>
        </div>
    </PlanIntroCard >;
}

export default PlanIntro;